export const stringsKey = "ActionColumn";
export const englishStrings = {
	deleteDialogTitle: "Delete?",
	deleteDialogText: "Are you sure you want to delete this variable?",
	cancelText: "Cancel",
	deleteDialogConfirm: "Yes",
	editDialogTitle: "Edit Variable",
	editDialogName: "Name",
	editDialogValue: "Value",
	editDialogGroup: "Group",
	editDialogConfirm: "Edit",
};
